import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  currentLanguage: string;
  public LangNotefier = new EventEmitter();

  constructor() {
    this.currentLanguage = localStorage.getItem("lang");
  }

  setLanguage(lang: string) {
    this.currentLanguage = lang;
    this.LangNotefier.emit(this.currentLanguage);
  }
}
